import React, { memo } from 'react';

import { Col, Typography } from 'antd';

import CustomCopyToClipboard from 'components/CustomCopyToClipboard';
interface IProps {
  urlSun: string;
  urlChk: string;
}

const LinksClipBoard = ({ urlSun, urlChk }: IProps) => {
  const hasCampaing = urlSun.toLowerCase().includes('edzz.la') || urlChk.toLowerCase().includes('edzz.la');
  return (
    <>
      {urlChk && (
        <Col md={12} xs={24}>
          <Typography.Text strong className='block' style={{ color: '#192542' }}>
            {hasCampaing ? 'URL Gerada:' : 'URL Novo Checkout Sun:'}
          </Typography.Text>

          <CustomCopyToClipboard fullWidth text={urlChk} disableUnderline />
        </Col>
      )}

      <Col md={12} xs={24}>
        <Typography.Text strong className='block' style={{ color: '#192542' }}>
          {hasCampaing ? 'URL Gerada:' : 'URL Checkout Sun:'}
        </Typography.Text>

        <CustomCopyToClipboard fullWidth text={urlSun} disableUnderline />
      </Col>
    </>
  );
};

export default memo(LinksClipBoard);
